import React from 'react'
import PropTypes from 'prop-types'
import LayoutDefault from '../../layouts/Default/index'
import layout from '../../config/layouts/home'
import { Async } from 'react-async'
import fetchData from '../../modules/fetch-data'
import loadable from '@loadable/component'
const HomeScreen = loadable(() => import('./screens/HomeScreen'))

const Home = ({ initialData, match, ...props }) => (
  <Async promiseFn={fetchData} version="v2" location="home" initialValue={initialData}>
    {({ data, error, isPending, isFulfilled }) => (
      <LayoutDefault adIds={layout.general.adIds} meta={isFulfilled && data.meta} {...props}>
        <HomeScreen
          response={isFulfilled && data}
          loading={isPending}
          error={error}
          ready={isFulfilled}
          match={match}
        />
      </LayoutDefault>
    )}
  </Async>
)

Home.getInitialData = ({ req }) => {
  return fetchData({ location: 'home', version: 'v2' })
}

Home.propTypes = {
  topTopics: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.string),
    articles: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
}

export default Home
